<template>
  <PageHeader v-if="!insideMobileApp && hasData" :step="step"></PageHeader>
  <MainContainer>
    <template v-if="!loading">
      <template v-if="hasData">
        <StepProgress class="lg:invisible" :step="step"></StepProgress>
        <template v-if="step===2">
          <template v-if="nps.type === '5645645' || nps.type === '6512645'">
            <StepQuestions5645645 v-if="nps.type === '5645645'" :flow-id="flowId"
                                  v-model:finished="questionsFinished"></StepQuestions5645645>
            <StepQuestionsSiri v-if="nps.type === '6512645'" :flow-id="flowId"
                               v-model:finished="questionsFinished"></StepQuestionsSiri>
          </template>
          <template v-else>
            <StepQuestionsGeneric v-if="nps.template" :nps="nps" :flow-id="flowId" v-model:finished="questionsFinished"></StepQuestionsGeneric>
            <div v-else>Prišlo je do napake pri pripravi NPS. Nimam vseh podatkov.</div>
          </template>
        </template>

        <StepThankYou v-if="step===3" :show-more="!insideMobileApp"></StepThankYou>
      </template>
      <template v-if="!hasData">
        <p class="text-center font-bold text-2xl">Hvala za vaš odziv! Vidimo, da ste že oddali mnenje. Če imate še kakšno vprašanje, smo tukaj za vas.</p>
      </template>
    </template>
  </MainContainer>
  <AppNavigation v-if="hasData && !loading && showNavigation">
    <AppBtn :text="navigationText" @click="next" :disabled="!questionsFinished"/>
  </AppNavigation>
</template>

<script>

import PageHeader from '@/components/PageHeader.vue'
import AppBtn from '@/components/AppBtn.vue'
import MainContainer from '@/components/MainContainer'
import AppNavigation from '@/components/AppNavigation'
import StepQuestions5645645 from '@/views/pools/StepQuestions5645645'
import StepThankYou from '@/views/StepThankYou'
import NPSService from '@/services/nps'
import StepQuestionsSiri from '@/views/pools/StepQuestionsSiri'
import StepQuestionsGeneric from '@/views/pools/StepQuestionsGeneric'
import StepProgress from '@/components/StepProgress.vue'

export default {
  name: 'App',
  components: {
    StepQuestionsGeneric,
    StepProgress,
    StepQuestionsSiri,
    StepThankYou,
    StepQuestions5645645,
    AppNavigation,
    MainContainer,
    AppBtn,
    PageHeader
  },
  data () {
    return {
      step: 2,
      loading: true,
      flowExists: false,
      questionsFinished: false,
      nps: null
    }
  },
  mounted () {
    let nps = new NPSService()
    nps.info(this.flowId).then((response) => {
      this.nps = response.data
      this.flowExists = true
    }, () => {
      this.flowExists = false
    }).finally(() => {
      this.loading = false
    })
  },
  computed: {
    insideMobileApp () {
      let standalone = window.navigator.standalone,
        userAgent = window.navigator.userAgent.toLowerCase(),
        safari = /safari/.test(userAgent),
        ios = /iphone|ipod|ipad/.test(userAgent)

      if (ios) {
        if (!standalone && safari) {
          // Safari
          return false
        } else if (!standalone && !safari) {
          // iOS webview
          return true
        }
      } else {
        if (userAgent.includes('wv')) {
          // Android webview
          return true
        } else {
          // Chrome
          return false
        }
      }
      return false
    },
    hasData () {
      return this.flowId && this.flowId.length > 0 && this.flowExists
    },
    flowId () {
      let fId = ''
      window.location.pathname.split('/').forEach(item => {
        if (item && item.length > 0) {
          fId = fId + item
        }
      })
      return fId
    },
    showNavigation () {
      if (this.step == 3) {
        return false
      }
      return true
    },
    navigationText () {
      if (this.step < 3) {
        return 'Naprej'
      }
      return 'Preberite več'
    }
  },
  methods: {
    next () {
      if (this.step == 2) {
        // finish!
        let nps = new NPSService()
        nps.finished(this.flowId).then(() => {
          this.step += 1
        })
      } else if (this.step < 3) {
        this.step += 1
      }
    },
  }
}
</script>

